import { useCallback } from 'react';
import { useDialog } from '@workspace/design-system/src/components';
import { Channel } from '@src/models/channel';
import { ChannelDetailModal } from '@src/pages/Studio/Channel/channel-detail/channel-detail-modal';
import { PaymentRequestFormData, PaymentRequestFormModal } from '@src/pages/Studio/Channel/payment-request/payment-request-form-modal';
import { ChannelSearchModal } from '@src/pages/Studio/Channel/components';



export function useChannelModals() {
  const { openDialog, closeDialog } = useDialog();

  const handleApplyPlanSuccess = useCallback(async (channelId: string, formData: PaymentRequestFormData) => {
    // API 연동 예정: 실제 서비스 호출로 대체하고 성공 시 토스트/리패치 등을 처리하세요.
    console.log('요금제 적용:', { channelId, formData });
    closeDialog();
  }, [closeDialog]);

  // 요금제 적용 폼 모달 열기 (직접 호출)
  const openPlanForm = useCallback((channelData: Channel) => {
    openDialog(
      <PaymentRequestFormModal
        channel={channelData}
        mode="apply"
        onClose={closeDialog}
        onSubmit={async (formData) => await handleApplyPlanSuccess(channelData.channelId, formData)}
      />
    );
  }, [openDialog, closeDialog, handleApplyPlanSuccess]);


  // 요금제 적용 플로우 시작 (필수 정보 체크 포함)
  const openApplyPlanFormModal = useCallback((channelData: Channel) => {
    openPlanForm(channelData);

  }, [openPlanForm]);


  // 채널 상세 모달 열기
  const openDetailModal = useCallback(
    (channel: Channel, initialTab?: 'info' | 'plan' | 'payment') => {
      openDialog(
        <ChannelDetailModal
          channel={channel}
          onClose={closeDialog}
          onApplyPlan={() => openApplyPlanFormModal(channel)}
          initialTab={initialTab}
        />
      );
    },
    [openDialog, closeDialog, openApplyPlanFormModal]
  );

  return {
    openDetailModal,
    openApplyPlanWithChannel: openApplyPlanFormModal,
  };
}
